module.exports = __webpack_public_path__ + "img/price-quote-title.91718e30.svg";